/* Aba Espécies: consulta rápida dos 63 códigos. Clicar num código abre um caso novo já com ele. */
import { $, $$, esc } from "../util.js";
import { S } from "../estado.js";
import { ESPECIES } from "../dados/especies.js";
import { abrirFicha } from "./ficha.js";

export function renderEspecies(){
  const q=S.buscaEsp.trim().toLowerCase();
  const lista=ESPECIES.filter(([cod,nome,a])=>{
    if(S.filtroEsp==="ativo"&&!a) return false;
    if(S.filtroEsp==="extinto"&&a) return false;
    return !q||(cod+" "+nome).toLowerCase().includes(q);
  });
  $("#vEspecies").innerHTML=`<div class="panel"><div class="tbl-scroll"><table>
    <thead><tr><th style="width:82px">Código</th><th>Espécie de benefício</th><th style="width:104px">Situação</th></tr></thead>
    <tbody>${lista.length?lista.map(([cod,nome,a])=>`<tr data-cod="${cod}">
      <td><span class="code${a?"":" ext"}">${cod}</span></td>
      <td style="${a?"":"color:var(--muted)"}">${esc(nome)}</td>
      <td><span class="status-pill"><i class="dot" style="background:${a?"var(--conc)":"var(--cinza)"}"></i>${a?"Ativo":"Extinto"}</span></td></tr>`).join("")
      :`<tr><td colspan="3"><div class="empty"><h3>Nenhum código encontrado</h3><p>Tente outro termo, como "pensão" ou "B87".</p></div></td></tr>`}
    </tbody></table></div></div>`;
  $$("#vEspecies tbody tr[data-cod]").forEach(tr=>tr.addEventListener("click",()=>abrirFicha(null,tr.dataset.cod)));
}
